import React from 'react';
import Menu from './Menu/menu';

const Layout = (props) => {
    return (
        <div className='app-layout'>
            <Menu />
            <main className='main-content'>
                <div className='page-container'>
                    {props.children}
                </div>
            </main>
        </div>
    );
};

export default Layout;
